import { render, staticRenderFns } from "./HeaderTabItem.vue?vue&type=template&id=004d7090"
import script from "./HeaderTabItem.vue?vue&type=script&lang=js"
export * from "./HeaderTabItem.vue?vue&type=script&lang=js"
import style0 from "./HeaderTabItem.vue?vue&type=style&index=0&id=004d7090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports